import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import BaseDialogLayoutHeader from './BaseDialogLayoutHeader';
import BaseDialogLayoutContent from './BaseDialogLayoutContent';
import BaseDialogLayoutFooter from './BaseDialogLayoutFooter';

import './BaseDialogLayout.scss';

function BaseDialogLayout(props) {
  const { size = 'lg', style, closeBtn = true, selfClose, className, resizable = false } = props;
  const closeButton = closeBtn ? (
    <ButtonWithIcon
      type="link"
      size="small"
      sprite="Close"
      linkIconSize="xs"
      iconOnly
      data-e2e="modal-close-button"
      onClick={selfClose}
      className="els-btn-modal-close e2e-modal-close">
      Close
    </ButtonWithIcon>
  ) : null;

  return (
    <section
      role="dialog"
      tabIndex="-1"
      style={style}
      className={classnames('base-dialog-layout', `base-dialog-layout-${size}`, resizable && 'base-dialog-layout-resizable', className)}>
      {closeButton}
      <BaseDialogLayoutHeader {...props} />
      <BaseDialogLayoutContent {...props} />
      <BaseDialogLayoutFooter {...props} />
    </section>
  );
}

BaseDialogLayout.propTypes = {
  size: PropTypes.oneOf(['fit', 'sm', 'md', 'lg', 'xl']),
  style: PropTypes.object,
  closeBtn: PropTypes.bool,
  className: PropTypes.string,
  selfClose: PropTypes.func,
  resizable: PropTypes.bool,
};

export default BaseDialogLayout;
